<script>
	import { getContext, onMount } from "svelte";
	import { fly } from "svelte/transition";

	import BoardC from "./board/Board.svelte";

	import { TOASTS_KEY } from "../../components/toasts/toast.js";

	import { crate } from "../../wasm.js";
	const { Color } = crate;

	export let engine;

	let { addToast } = getContext(TOASTS_KEY);

	let root;
	let boardSize;

	function computeBoardSize() {
		const rect = root.getBoundingClientRect();
		boardSize = Math.min(rect.width, rect.height);
		boardSize -= 2 * 5;
	}

	let observer;
	onMount(() => {
		computeBoardSize();

		observer = new ResizeObserver((entries) => {
			computeBoardSize();
		});
		observer.observe(root);

		addToast({
			content: "Your game has started !!",
			duration: 5000,
		});

		return function () {
			observer.disconnect();
		};
	});

	$: isInCheck = engine.is_in_check();
	$: legalMoves = engine.legal_moves();
	$: colorToMove = engine.color_to_move();

	$: oppositeColor = colorToMove === Color.White ? Color.Black : Color.White;

	$: if (colorToMove === Color.White) {
		document.documentElement.classList.remove("dark");
	} else {
		document.documentElement.classList.add("dark");
	}

	$: gameEnded = (() => {
		if (legalMoves.length === 0) {
			return { kind: "Checkmate", color: oppositeColor };
		}
		return undefined;
	})();
</script>

<div class="root centered" bind:this={root}>
	<div class="left-panel" />
	<div class="board-container centered">
		<div class="board centered">
			<BoardC bind:engine size={boardSize} />
			{#if gameEnded}
				<div class="announce centered">
					<div
						class="announce-msg"
						in:fly={{ y: 20, duration: 1000 }}
						out:fly={{ y: -20, duration: 1000 }}
					>
						{#if gameEnded.kind === "Checkmate"}
							{gameEnded.color === Color.White
								? "White"
								: "Black"} won by Checkmate
						{/if}
					</div>
				</div>
			{/if}
		</div>
	</div>
	<div class="right-panel centered">
		{#if gameEnded}
			<!-- <div class="game-end-description">
				{#if gameEnded.kind === "Checkmate"}
					{gameEnded.color === Color.White ? "White" : "Black"} won by
					Checkmate.
				{/if}
			</div> -->
		{:else}
			<div class="turn-indicator">
				{colorToMove === Color.White ? "White" : "Black"} to move
			</div>
		{/if}
	</div>
</div>

<style>
	.root {
		width: 100%;
		height: 100%;
		display: grid;
		grid-template-columns: 1fr min-content 1fr;
		grid-template-rows: 1fr;
		user-select: none;
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
	}

	.board-container {
		width: 100%;
		height: 100%;
	}

	.board {
		position: relative;
		border: solid 2px var(--fg-color);
	}

	.announce {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.667);
	}

	.announce-msg {
		color: var(--light-color);
		font-size: 20px;
		padding: 10px;
		border: solid 2px var(--light-color);
		background-color: var(--dark-color);
	}

	.left-panel {
	}

	.right-panel {
	}

	.turn-indicator {
		color: var(--fg-color);
		font-size: 20px;
		border-bottom: solid 2px var(--fg-color);
		padding: 10px;
	}
</style>
